var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeaver00(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2296,
    height: 1071,
    viewBox: "0 0 2296 1071",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460.684 935.972C474.92 935.972 489.155 935.972 543.926 935.972C598.696 935.972 693.571 935.972 749.4 935.265C805.229 934.558 819.137 933.144 860.123 932.034C901.108 930.924 968.748 930.161 1007.73 929.004C1046.71 927.847 1054.98 926.321 1195.53 925.039C1336.08 923.758 1608.67 922.768 1751.91 922.583C1895.15 922.398 1900.79 923.049 1911.48 923.384C1922.18 923.719 1937.76 923.719 1941.18 922.103C1965.45 910.633 1883.27 886.362 1856.94 865.891C1851.98 862.033 1847.05 860.766 1801.34 851.12C1755.64 841.474 1668.87 824.019 1449.03 812.408C1229.19 800.796 878.895 795.558 696.594 792.646C514.292 789.734 510.595 789.308 503.621 789.088C496.647 788.868 486.509 788.868 513.261 784.639C540.013 780.409 603.962 771.951 807.821 767.012C1011.68 762.074 1353.51 760.912 1556.46 757.666C1759.41 754.419 1813.12 749.123 1862.06 746.395C1911 743.667 1953.54 743.667 1980.7 743.51C2007.86 743.352 2018.36 743.036 1790.49 740.041C1562.62 737.046 1096.08 731.381 851.799 728.491C607.518 725.602 599.639 725.659 603.905 722.106C608.172 718.554 624.823 711.389 656.116 701.745C687.409 692.101 732.839 680.194 829.168 665.268C925.497 650.343 1071.35 632.76 1160.94 620.365C1250.54 607.971 1279.46 601.298 1389.93 597.366C1500.41 593.433 1691.56 592.443 1790.18 584.389C1888.8 576.334 1889.08 561.246 1889.08 550.715C1889.09 540.183 1888.8 534.666 1882.96 530.947C1877.12 527.228 1865.72 525.475 1617.24 515.982C1368.76 506.489 883.54 489.31 815.009 478.582C746.478 467.854 1109.34 464.096 1306.64 457.583C1503.94 451.07 1524.68 441.916 1624.42 438.304C1724.17 434.693 1902.28 436.902 1915.77 430.032C1929.26 423.162 1772.71 407.145 1457.49 398.894C1142.26 390.643 673.103 390.643 751.893 390.643C830.684 390.643 1471.64 390.643 1750.75 385.242C2029.85 379.841 1927.67 369.039 1632.68 362.72C1337.68 356.401 852.959 354.893 629.654 348.624C406.349 342.355 459.147 331.371 724.711 324.829C990.274 318.288 1467 316.52 1757.68 317.791C2048.37 319.061 2138.56 323.423 2183.43 325.298C2228.3 327.174 2225.13 326.432 1891.31 322.218C1557.49 318.004 893.121 310.341 607.556 294.707C321.991 279.074 435.358 255.701 763.851 242.818C1092.34 229.935 1632.52 228.249 1884.69 224.753C2136.86 221.257 2084.64 216.003 1745.59 213.906C1406.54 211.809 782.239 213.028 454.93 214.307C127.621 215.585 116.221 216.887 438.388 213.688C760.555 210.49 1416.64 202.752 1756.87 199.063C2097.1 195.374 2101.61 195.968 2107.45 196.274C2113.29 196.581 2120.32 196.581 1996.92 181.593C1873.51 166.606 1619.46 136.632 1240 118.645C860.545 100.659 363.39 95.5684 394.036 94.2897C424.682 93.0109 998.194 95.6979 1319.74 100.397C1641.28 105.095 1693.47 111.725 1723.18 115.14C1768.7 120.372 1784.99 120.356 1810.82 125.491C1817.07 126.734 1821.49 126.542 1812.78 126.542C1782.14 126.542 1752.66 127.249 1729.07 128.759C1660.77 133.128 1660.6 139.958 1600.21 158.616C1544.06 175.965 1434.61 205.008 1185.85 249.394C937.09 293.781 551.949 351.531 333.385 387.237C114.821 422.942 74.5037 434.854 376.434 440.753C678.364 446.652 1323.76 446.178 1661.27 447.164C1998.77 448.15 2008.82 450.61 1776.06 456.615C1543.29 462.62 1067.39 472.096 844.262 473.644C621.129 475.191 665.177 468.522 828.353 465.087C991.529 461.652 1272.5 461.652 1298.38 473.293C1324.26 484.935 1086.54 508.219 962.324 520.752C838.111 533.284 834.612 534.361 1044.67 534.916C1254.74 535.471 1678.47 535.471 1891.05 536.915C2103.64 538.36 2092.24 541.25 1913.02 544.225C1733.8 547.199 1387.1 550.172 1218.26 550.416C1049.42 550.66 1068.95 548.085 1141.22 544.81C1213.5 541.535 1337.93 537.638 1340.84 541.274C1343.75 544.909 1221.37 556.195 1090.8 563.228C960.229 570.26 825.184 572.699 686.046 575.212",
    stroke: "#8C7868",
    strokeWidth: 188,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1831.76 281.972C1817.53 281.972 1803.29 281.972 1748.52 281.972C1693.75 281.972 1598.87 281.972 1543.05 282.433C1487.22 282.893 1473.31 283.815 1432.32 284.539C1391.34 285.263 1323.7 285.761 1284.72 286.515C1245.74 287.269 1237.47 288.264 1096.92 289.1C956.363 289.935 683.779 290.581 540.537 290.701C397.296 290.822 391.657 290.397 380.961 290.179C370.264 289.96 354.681 289.96 351.262 291.014C326.994 298.493 409.173 314.318 435.502 327.665C440.465 330.181 445.395 331.007 491.101 337.297C536.806 343.586 623.573 354.967 843.416 362.538C1063.26 370.108 1413.55 373.524 1595.85 375.423C1778.15 377.321 1781.85 377.599 1788.82 377.743C1795.8 377.886 1805.94 377.886 1779.18 380.644C1752.43 383.401 1688.48 388.916 1484.62 392.136C1280.76 395.356 938.931 396.114 735.981 398.231C533.031 400.347 479.323 403.8 430.386 405.579C381.448 407.358 338.907 407.358 311.745 407.461C284.584 407.563 274.09 407.769 501.956 409.722C729.822 411.675 1196.37 415.369 1440.65 417.253C1684.93 419.137 1692.81 419.1 1688.54 421.416C1684.27 423.732 1667.62 428.404 1636.33 434.692C1605.04 440.98 1559.61 448.744 1463.28 458.475C1366.95 468.207 1221.1 479.672 1131.5 487.753C1041.91 495.834 1012.99 500.185 902.515 502.749C792.039 505.313 600.881 505.959 502.265 511.21C403.649 516.462 403.367 526.3 403.363 533.166C403.359 540.033 403.641 543.631 409.484 546.056C415.327 548.48 426.722 549.623 675.203 555.813C923.685 562.002 1408.91 573.203 1477.44 580.198C1545.97 587.193 1183.1 589.643 985.805 593.89C788.505 598.136 767.766 604.106 668.023 606.46C568.279 608.815 390.161 607.374 376.675 611.854C363.189 616.333 519.732 626.776 834.957 632.156C1150.18 637.536 1619.34 637.536 1540.55 637.536C1461.76 637.536 820.801 637.536 541.698 641.058C262.594 644.579 364.771 651.622 659.768 655.742C954.765 659.862 1439.49 660.846 1662.79 664.933C1886.1 669.021 1833.3 676.183 1567.73 680.448C1302.17 684.713 825.443 685.866 534.761 685.037C244.079 684.209 153.889 681.365 109.016 680.142C64.1431 678.919 67.3197 679.403 401.139 682.151C734.958 684.898 1399.32 689.895 1684.89 700.088C1970.45 710.282 1857.09 725.521 1528.59 733.921C1200.1 742.321 659.921 743.42 407.754 745.7C155.588 747.979 207.807 751.405 546.857 752.772C885.907 754.14 1510.21 753.345 1837.52 752.511C2164.82 751.677 2176.22 750.829 1854.06 752.914C1531.89 755 875.81 760.045 535.576 762.45C195.341 764.855 190.833 764.468 184.994 764.268C179.155 764.069 172.121 764.069 295.526 773.841C418.931 783.612 672.989 803.156 1052.44 814.884C1431.9 826.612 1929.06 829.931 1898.41 830.764C1867.76 831.598 1294.25 829.846 972.708 826.782C651.166 823.719 598.972 819.396 569.265 817.17C523.748 813.758 507.451 813.769 481.63 810.421C475.379 809.61 470.957 809.735 479.665 809.735C510.302 809.735 539.789 809.274 563.38 808.29C631.678 805.441 631.845 800.988 692.236 788.822C748.389 777.511 857.836 758.574 1106.6 729.633C1355.36 700.692 1740.5 663.038 1959.06 639.757C2177.62 616.476 2217.94 608.71 1916.01 604.864C1614.08 601.017 968.682 601.326 631.178 600.683C293.673 600.041 283.621 598.437 516.389 594.521C749.157 590.606 1225.05 584.427 1448.18 583.418C1671.32 582.409 1627.27 586.757 1464.09 588.997C1300.92 591.237 1019.95 591.237 994.066 583.647C968.185 576.056 1205.91 560.875 1330.12 552.703C1454.33 544.531 1457.83 543.829 1247.77 543.468C1037.71 543.106 613.98 543.106 401.393 542.164C188.806 541.222 200.202 539.338 379.424 537.398C558.646 535.458 905.348 533.52 1074.19 533.361C1243.03 533.202 1223.5 534.881 1151.22 537.017C1078.95 539.152 954.516 541.692 951.606 539.322C948.697 536.952 1071.08 529.593 1201.65 525.008C1332.22 520.422 1467.26 518.832 1606.4 517.194",
    stroke: "#8C7868",
    strokeWidth: 188,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M751.788 967.48C750.941 958.61 748.633 936.676 747.539 910.035C746.344 880.948 761.055 850.193 763.576 839.244C767.182 823.584 769.375 804.618 770.852 788.037C773.525 758.047 776.783 735.785 780.002 719.522C783.695 700.873 790.207 669.474 794.684 652.591C797.085 643.535 803.467 627.661 815.804 602.654C832.588 568.634 847.762 548.616 851.296 543.939C858.292 534.683 861.974 527.9 872.599 512.914C890.555 487.588 893.081 475.2 897.254 465.204C902.78 451.969 909.976 444.515 913.036 434.461C920.078 411.327 899.733 392.197 893.292 383.296C888.489 376.659 887.275 369.973 888.037 370.776C901.722 385.195 903.297 397.402 913.515 406.633C919.419 411.966 930.881 407.578 963.966 395.219C997.049 382.86 1020.38 367.655 1036.22 361.19C1041.27 359.132 1055.91 359.464 1100.6 358.026C1132.9 356.986 1184.7 353.712 1213.33 351.585C1245.91 349.163 1258.19 345.716 1282.12 343.838C1320.06 340.86 1348.29 343.916 1359.26 347.246C1381.54 354.007 1389.4 357.462 1406.18 369.571C1418.36 378.36 1429.99 384.883 1450.82 391.879C1461.57 395.487 1470.73 377.281 1476.4 371.102C1482.53 364.428 1498.89 355.699 1508.05 351.924C1521.82 346.246 1483.28 391.195 1476.8 401.538C1468.59 414.631 1477.13 428.924 1483.74 447.894C1495 480.216 1509.38 503.422 1516.77 516.911C1530.55 542.095 1541.56 564.924 1548.19 576.267C1553.53 585.406 1556.91 599.926 1560.25 613.363C1562.6 622.777 1564.34 587.422 1569.77 582.779C1589.08 566.265 1606.18 565.412 1623.92 560.894C1637.28 557.492 1668.19 557.1 1688.98 561.018C1702.08 563.489 1709.98 576.222 1716.19 587.026C1722.65 598.264 1723.72 608.882 1724.21 622.764C1725.42 656.465 1724.74 681.485 1726.21 701.431C1727.5 718.832 1729.17 751.059 1730.25 768.693C1732.13 799.48 1730.54 825.532 1724.91 843.816C1717.67 867.31 1693.3 894.465 1687.26 902.692C1684.28 906.753 1684.61 911.788 1681.14 914.283C1675.41 918.411 1659.78 917.05 1635.72 917.946C1604.59 919.104 1582.34 922.476 1573.71 922.674C1569.73 922.766 1566.56 923.268 1539.37 923.972C1512.18 924.675 1461.06 925.673 1388.84 935.496C1316.63 945.318 1224.86 963.934 1121.39 974.755C1017.92 985.576 905.525 988.037 843.753 988.875C781.981 989.713 774.233 988.852 764.415 986.978C742.814 982.853 727 978.998 723.878 976.206C721.921 974.457 730.355 969.017 746.275 958.266C762.195 947.515 788.195 930.847 814.446 918.291C840.697 905.736 866.411 897.797 923.339 888.854C980.268 879.91 1067.63 870.203 1115.38 865.202C1163.13 860.202 1168.63 860.202 1189.61 856.072C1210.59 851.942 1246.89 843.682 1299.67 834.564C1352.46 825.446 1420.63 815.72 1475.26 810.28C1529.88 804.839 1568.89 803.979 1589.91 802.869C1610.93 801.759 1612.79 800.426 1615.23 797.099C1626.44 781.858 1633.16 769.7 1637.72 754.409C1644.68 731.081 1637.64 706.47 1634.52 693.788C1631.65 682.098 1628.9 674.679 1626.95 667.274C1625.9 663.324 1608.78 683.327 1578.25 701.82C1562.07 711.619 1541.59 716.961 1524.44 721.243C1507.3 725.525 1493.36 727.23 1483.86 728.108C1474.36 728.987 1469.71 728.987 1409 736.068C1348.28 743.149 1231.64 757.311 1169.97 765.201C1108.3 773.091 1105.13 774.28 1099.98 775.599C1087.89 778.697 1069.93 780.839 1047.58 783.56C1035.81 784.993 1023.31 787.485 989.022 789.009C954.731 790.533 899.063 791.256 869.996 789.627C840.929 787.997 840.148 783.992 839.497 775.349C837.856 753.577 838.487 738.019 841.919 731.481C855.45 705.698 877.516 693.947 900.821 683.229C909.408 679.28 922.711 677.243 1009.41 674.527C1096.11 671.811 1256.25 669.607 1340.01 668.29C1423.76 666.974 1426.3 666.612 1429.11 666.002C1453.57 660.687 1486.3 650.735 1489.19 647.952C1492.49 644.766 1489.07 637.881 1485.94 632.345C1483.04 627.209 1476.59 621.649 1469.77 615.621C1467.04 613.202 1465.5 612.399 1442.83 611.049C1420.16 609.699 1376.33 607.907 1332.32 610.023C1288.31 612.139 1245.46 618.219 1176.25 621.351C1107.04 624.482 1012.76 624.482 961.874 623.793C910.988 623.103 906.35 621.723 903.057 620.368C899.765 619.014 897.957 617.726 897.026 611.544C894.458 594.494 898.731 577.616 907.005 563.806C919.571 542.834 934.015 528.127 943.431 519.39C955.022 508.636 967.512 500.747 984.079 493.107C995.405 487.884 1013.66 482.259 1027.16 478.46C1040.66 474.662 1049.1 473.456 1067.9 472.835C1086.7 472.213 1115.61 472.213 1138.32 471C1161.03 469.786 1176.66 467.359 1191.72 464.448C1206.78 461.536 1220.79 458.214 1242.13 456.502C1263.46 454.791 1291.7 454.791 1311.84 456.496C1357.96 460.399 1371.66 469.185 1384.9 474.821C1389.09 476.607 1392.24 481.317 1395.39 486.34C1397.76 490.113 1396.72 496.236 1395.29 502.99C1394.54 506.538 1389.94 508.957 1372.12 515.467C1354.3 521.978 1322.42 532.157 1257.49 538.672C1192.55 545.187 1095.53 547.731 1042.46 549.731C989.394 551.731 983.219 553.111 983.451 552.13C983.682 551.149 990.508 547.766 1076.78 545.987C1163.04 544.207 1328.55 544.134 1501.12 544.743",
    stroke: "#8C7868",
    strokeWidth: 162,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M725.68 980.387C725.68 964.053 725.68 947.719 725.255 910.09C724.831 872.46 723.982 814.029 723.698 782.135C723.414 750.241 723.72 746.655 727.368 731.037C731.016 715.418 737.996 687.877 742.276 670.277C748.199 645.921 753.962 623.648 762.565 597.276C768.558 578.907 774.074 568.198 776.25 560.545C778.033 554.275 786.63 541.029 799.072 520.767C809.556 503.693 815.974 488.703 823.385 477.52M909.332 381.272C916.35 373.854 932.175 363.097 955.764 346.021C973.669 333.06 985.345 328.412 995.377 324.681C1014.62 317.521 1042 310.471 1067.79 304.892C1095.57 298.885 1109.31 300.385 1144.44 299.788C1151.75 299.664 1153.8 299.275 1181.21 299.098C1208.62 298.922 1261.33 298.922 1292.59 299.453C1332.1 300.125 1345.83 303.653 1355.87 306.168C1371.87 310.176 1389.43 312.1 1422.37 321.043C1437.65 325.19 1449.38 340.377 1460.19 350.952M1543.51 458.683C1554.3 474.431 1561.78 489.947 1569.08 503.481C1576.79 517.777 1582.75 533.651 1594.7 564.613C1604.22 589.274 1623.89 630.834 1637.1 663.396C1650.3 695.957 1657.26 717.937 1664.2 752.855C1671.15 787.773 1677.87 834.964 1681.33 861.297C1685.32 891.608 1685.91 902.525 1687.84 921.177C1689.14 950.19 1689.91 969.544 1690.44 973.215C1690.7 975.093 1690.93 977.003 1691.18 978.971",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M827.08 470.459C821.217 465.654 814.078 457.29 807.08 445.61C797.111 428.969 793.543 420.141 794.033 409.883C794.312 404.037 799.371 400.37 802.695 397.806C809.711 392.395 820.956 392.489 883.051 390.044C896.208 389.134 898.687 387.952 900.756 386.674C902.826 385.395 904.411 384.055 908.14 382.674",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1466.34 354.089C1506.56 356.418 1551.04 362.709 1559.61 368.073C1563.64 370.598 1566.11 375.011 1568.27 378.753C1572.87 386.728 1564.8 400.123 1561.03 411.876C1557.6 422.538 1550 428.978 1545.83 437.824C1544.65 440.065 1543.03 442.053 1541.71 444.158C1540.39 446.263 1539.41 448.424 1535.95 453.098",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.59 390.392L1472.54 404.928",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M875.571 450.919L891.594 441.139",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M914.731 986.158C899.236 918.903 898.32 894.826 898.215 864.556C898.12 837.482 899.233 786.633 901.788 753.204C905.476 704.96 915.77 684.147 931.847 657.066C944.481 635.785 969.161 601.027 989.48 575.322C1009.8 549.617 1025.77 534.486 1040.46 523.371C1066.65 503.557 1085.02 498.197 1102.89 496.841C1141.91 493.879 1170.75 495.135 1186.58 497.442C1220.92 502.448 1246.81 503.026 1259.86 507.409C1286.59 516.379 1310.7 524.137 1324.99 533.946C1356.66 555.679 1367.69 569.712 1380.89 580.63C1398.45 595.156 1409.86 620.762 1418.55 639.707C1424.7 653.137 1429.95 679.059 1433.75 695.987C1436.66 708.983 1440.28 728.506 1443.44 767.283C1445.55 793.107 1444.52 831.664 1443.98 853.093C1443.19 884.323 1439.17 897.907 1432.49 912.47C1423.91 931.149 1420.82 942.578 1418.07 954.463C1417.56 957.665 1417.23 960.805 1416.96 963.561C1416.69 966.317 1416.48 968.594 1414.31 974.259",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M954.793 948.188V965.298",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M966.103 946.176L981.958 962.161",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M991.084 936.489L1002.39 945.437",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.93 932.376L1036.97 950.972",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.46 946.297L1069.37 955.944",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.88 941.662L1107.36 957.55",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.58 918.964L1196.64 947.875",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.07 919.663L1270.5 937.996",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.96 923.882L1309.85 941.168",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.02 931.033L1339.16 948.927",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.99 949.538L1341.73 956.96",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M947.908 896.306V895.694",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M945.551 890.979L954.152 903.464",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M977.679 888.099C978.803 889.597 979.927 891.095 981.326 892.688C982.726 894.281 984.368 895.923 986.06 897.615",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M997.323 879.892L1014.97 900.51",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.92 882.693L1056.01 900.813",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.88 884.137L1075.18 902.564",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.62 871.527C1113.24 874.898 1115.86 878.27 1118.38 881.967C1120.9 885.664 1123.23 889.585 1125.64 893.625",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.32 872.318L1153.71 883.885",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.11 861.394L1239.6 878.595",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.8 867.597L1249.03 880.953",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.48 855.67L1343.99 868.59",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1361.52 860.11L1351.22 884.993",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.31 886.478V894.51",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M965.33 820.531L965.941 823.761",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M991.524 801.485L1001.96 810.915",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.48 791.663L1030.51 806.504",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.08 793.833L1049.99 812.957",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.93 806.585L1076.75 825.363",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.15 807.545L1108.59 824.743",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.33 808.667L1145.13 826.045",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1166 812.159L1170.68 832.418",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.05 824.866L1194.42 835.995",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.92 808.734L1247.73 826.371",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.3 800.403C1276.42 801.902 1277.54 803.4 1278.54 807.155C1279.54 810.909 1280.37 816.875 1281.23 823.022",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.08 799.163L1308.58 814.965",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.3 816.007L1337.92 822.99",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.06 822.157L1370.67 828.095",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.22 824.689V831.239",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M950.163 730.5C951.661 731.998 953.159 733.497 956.836 737.405C960.514 741.313 966.324 747.585 972.311 754.047",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M974.276 728.113L994.287 753.847",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.18 725.601L1029.73 748.482",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.67 733.543L1067.54 760.833",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.68 743.974C1090.52 746.482 1091.35 748.99 1091.98 753.034C1092.62 757.079 1093.02 762.585 1093.44 768.257",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.51 743.129L1129.3 764.795",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.71 760.013L1159.31 777.961",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1264.38 759.318L1257.39 776.168",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1278 765.561L1277.52 785.648",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.23 771.937L1300.36 786.17",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.93 779.357L1328.03 786.168",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.57 783.195L1365.96 787.387",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.93 791.359L1379.67 797.297",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.64 677.772C1003.64 677.974 1003.64 678.176 1004.66 679.18C1005.69 680.185 1007.73 681.985 1009.84 683.841",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.41 679.302L1040.72 697.298",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.16 678.773C1079.83 680.863 1081.5 682.953 1083.48 685.608C1085.47 688.263 1087.72 691.418 1090.03 694.67",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.39 690.4L1125.06 707.079",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.22 700.436L1161.98 711.526",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.43 702.266L1202.07 716.805",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.78 703.706L1207.44 725.537",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.97 690.65C1246.42 693.474 1247.88 696.297 1248.36 699.35C1248.84 702.404 1248.31 705.601 1247.76 708.896",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1276.29 696.606L1274.68 710.752",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1337.16 691.401L1334.28 710.258",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.78 710.866L1384.58 731.339",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.98 732.078L1388.64 747.924",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.85 617.822C1033.3 620.358 1035.75 622.893 1037.79 625.193C1039.84 627.493 1041.41 629.481 1043.03 631.53",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.97 610.352L1069.9 638.533",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.29 628.169L1124.98 644.951",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.38 612.807L1165.29 635.954",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.82 617.596C1197.07 620.104 1198.33 622.612 1199.17 625.416C1200.02 628.22 1200.43 631.245 1200.84 634.362",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.6 595.919L1265.19 625.531",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.59 615.08C1310.47 625.724 1310.36 636.367 1309.11 642.47C1307.86 648.572 1305.49 649.811 1303.04 651.087",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.47 640.653L1358.59 655.317",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.49 647.718L1363.88 659.42",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.89 544.661C1095.89 545.525 1095.89 546.389 1097.07 550.163C1098.25 553.937 1100.62 560.594 1103.05 567.453",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.4 542.642L1152 564.913",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.49 553.642L1177.07 560.452",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.84 560.583L1190.07 570.797",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaver00);
export default __webpack_public_path__ + "static/media/beaver00.c9654b603858bc5e4340c16564df811e.svg";
export { ForwardRef as ReactComponent };